import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class PurchaseAcceptanceApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'purchaseAcceptance'
  }



}